/**
 * 评语列表管理功能
 * @Author:wuTao
 * @Date 2020/08/18
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateConfig, templateConfig} from './config';

import {framework_tool,component_tool} from '@/tool';

let {WizContainer, WizReduxTemplate} = framework_tool;
let { WizBrowserExport} = component_tool;

class TrainPathCommentList extends WizContainer {

  componentName = 'TrainPathCommentList';

  constructor(props) {
    super(props);
    this.state = {}
  }

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleTrainPathComment(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  /**
   * 下载操作
   * @param nextProps
   * @param nextState
   * @param key
   * @private
   */
  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '课程id',
        field: 'id',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '课程名称',
        field: 'name',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '课程编码',
        field: 'code',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '状态',
        field: 'statusStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '结束时间',
        field: 'endDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '课程分类',
        field: 'categoryNames',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '创建人',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '发布时间',
        field: 'createTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }



    ]
    if (o['success']) {
      let data = o['data']
      WizBrowserExport({
        title: '线下课程信息',
        sheetName: '线下课程信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '线下课程信息.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig,
      apiDataFormat: {
        add: this._handleTrainPathComment,
        update: this._handleTrainPathComment,
        delete: this._handleTrainPathComment,
        updateState: this._handleTrainPathComment,
        look: this._handleTrainPathComment,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(TrainPathCommentList);
